import { render } from "./QuickLinks.vue?vue&type=template&id=3ebd63b6"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__